import React, { Component } from 'react'

import { Get } from 'utils/axios-token'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

const HOC = WrappedComponent => {
  class WithHOC extends Component {
    state = {
      loading: false,
      newsletterRecipientGroups: []
    }

    load = param => this.setState({ loading: param })

    getNewsletterRecipientGroups = () => Get(
      `/sites/${ this.props.site.id }/recipient_groups?query=${ convertSearchObjectToBase64({ is_paginated: false }) }`,
      this.getNewsletterRecipientGroupsSuccess,
      this.getNewsletterRecipientGroupsError,
      this.load
    )
    getNewsletterRecipientGroupsSuccess = payload => this.setState({
      newsletterRecipientGroups: payload.data.map( recipientGroup => ({
        ...recipientGroup,
        value: recipientGroup.id,
        label: recipientGroup.name
      }))
    })
    getNewsletterRecipientGroupsError = () => {}

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          onLoadNewslettersHOC={ this.state.loading }
          newsletterRecipientGroups={ this.state.newsletterRecipientGroups }
          getNewsletterRecipientGroups={ this.getNewsletterRecipientGroups }
        />
      )
    }
  }
  return WithHOC
}

export default HOC
